import request from '@/utils/request'

export function getBuildingInTree(params) {
  return request({
    url: `/api/v3/asset/tree`,
    method: 'get',
    params
  })
}

export function addBuilding(data) {
  return request({
    url: `/api/v3/asset/building`,
    method: 'post',
    data
  })
}

export function editBuilding(data) {
  return request({
    url: `/api/v3/asset`,
    method: 'put',
    data
  })
}

export function delBuilding(ids) {
  return request({
    url: `/api/v3/asset/building`,
    method: 'delete',
    data: ids
  })
}

export function delOneBuilding(id) {
  return request({
    url: `/api/v3/asset/building`,
    method: 'delete',
    data: [id]
  })
}
